import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';

/**
 * Returns if the quick compose form is in edit mode or not
 * If true - the form is in edit mode, otherwise it's in compose mode
 */
export default function isQuickComposeInEditMode(): boolean {
    return !isCalendarEventLocalLie(getComposeStore().event);
}
